import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-parallelLines",
  "use": "icon-parallelLines-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-parallelLines\"><path d=\"M831.37.194l40.102 40.102L40.102 871.61 0 831.507zm152.86 152.362l40.102 40.103L192.962 1024l-40.102-40.103z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol